import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconArrowDescending = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--arrow-descending")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="Property 1=directional sort, Property 2=decending">
  <path id="icon--centivo--arrow-descending" fillRule="evenodd" clipRule="evenodd" d="M11.6263 1.42042C11.8252 1.19666 12.1748 1.19666 12.3737 1.42042L19.2603 9.16782C19.5469 9.49027 19.318 10 18.8866 10H5.11342C4.682 10 4.45309 9.49027 4.73972 9.16782L11.6263 1.42042Z" fill="currentColor"/>
  </g>
  </IconWrapper>
)
